import getDefaultLogo from './getDefaultLogo';
export default getDefaultLogo;
